import { ChartData } from "../components/charts/types";
import { makeAPIRequest } from "../helpers/apiCall";

/**
 * Retrieves all snapshot data for the given identifier.
 *
 * @param {number|string} id - The identifier used to fetch snapshot data.
 * @param {URLSearchParams|null} params - The URL search parameters for the request.
 * @returns {Promise<{ data: ChartData }>} A promise that resolves with the snapshot data.
 */
function getAll(
  id: number | string,
  params: URLSearchParams = null,
): Promise<{ data: ChartData }> {
  return makeAPIRequest({
    url: `/snapshots/${id}/data`,
    params,
    method: "get",
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}
export const snapshotDataService = {
  getAll,
};
